import './ScrollContainer.sass';

export const ScrollContainer = ({children}) => {
  return (
    <div className="scroll-container">
      {children}
    </div>
  )
}
